/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/common/messages.ts" />

module Meevo.Components {

  import ScanOpeningContainer = Meevo.Model.ScanOpeningContainer;
  import Messages = Meevo.Components.Common.Messages;
  import IScanRequest = Meevo.Model.IScanRequest;
  import IAppSettings = Meevo.Components.Common.IAppSettings;
  import Client = Meevo.Model.Client;
  import ClientTypeEnum = Meevo.Model.ClientTypeEnum;
  import IModalService = Meevo.Components.Modal.IModalService;
  import IDataService = Meevo.Components.BaseClasses.IDataService;

  export class SuggestionsService implements ISuggestionsService {
    private activeRequestId: string = null;
    private isRequestedEmployee: boolean = false;

    public suggestions: ScanOpeningContainer[] = null;
    public payingClient: any = null;
    public suggestionServiceId: any;
    public copyScanRequest: IScanRequest=null;
    public initScanResult:any;
    constructor(
      private $q: ng.IQService,
      private $http: ng.IHttpService,
      private $rootScope: ng.IRootScopeService,
      private globals: any,
      private appSettings: IAppSettings,
      private modalService: IModalService,
       private dataService: IDataService,
      protected $translate: angular.translate.ITranslateService,
      private $locale: angular.ILocaleService) {
    }

    public getSuggestions(request: IScanRequest): void {
        this.copyScanRequest = request;
        if (!request) {
            this.setSuggestions([]);
            return;
      }

      if (request.overallRequestedEmployees && request.overallRequestedEmployees.length > 0) {
        this.isRequestedEmployee = true;
      } else {
        this.isRequestedEmployee = false;
      }

      const url = `/${this.appSettings.API_ROOT}/AppointmentBook/Suggestions`;
        this.$http.post(url, request).then(response => {
            this.initScanResult = <ScanOpeningContainer[]>response.data;
        this.setSuggestions(<ScanOpeningContainer[]>response.data);
      });
    }

    public bookFromSuggestion(opening: ScanOpeningContainer, payingClient: Client, payingClientType: ClientTypeEnum, notes: string): ng.IPromise<any> {
        var defered = this.$q.defer();
        if (!opening) {
            return;
      }
      this.handleUdfs(opening).then(() => {
          this.book(opening, payingClient, payingClientType, notes).then(() => {
              defered.resolve();
          });
      });
      return defered.promise;
    }

    private book(opening: ScanOpeningContainer, payingClient: Client, payingClientType: ClientTypeEnum, notes: string): ng.IPromise<any> {
        var defered = this.$q.defer();

        if (!opening) {
            return;
        }
        const url = `/${this.appSettings.API_ROOT}/AppointmentBook/Suggestions/Book`;
        const request = {
            payingClientId: payingClient.id,
            payingClientType: payingClientType,
            openingContainer: opening,
            notes: notes,
            isRequestedEmployee: this.isRequestedEmployee,
            locale: this.$locale.id,
            timeFormat: this.appSettings.APP_TIME_FORMAT
        };
        this.$http.post(url, request).then(response => {
            const appointmentsBooked = <number>response.data;
            if (appointmentsBooked > 0) {
                this.$rootScope.$broadcast(Messages.APPOINTMENT_BOOK_SUGGESTION, request);
                this.setSuggestions([]);
                defered.resolve();
            }

           if (response.data["responseStatus"] != null && response.data["responseStatus"].errors != null && response.data["responseStatus"].errors[0].errorCode == "20123")
           {
                this.modalService.confirm("MESSAGE_DOUBLEBOOK_WARNING",0,true).then((result) =>
                {
                    if (result)
                    {
                        const request = {
                            payingClientId: payingClient.id,
                            payingClientType: payingClientType,
                            openingContainer: opening,
                            notes: notes,
                            isRequestedEmployee: this.isRequestedEmployee,
                            suppressWarnings: true
                        };

                        this.$http.post(url, request).then(response => {
                            const appointmentsBooked = <number>response.data;
                            if (appointmentsBooked > 0) {
                                this.$rootScope.$broadcast(Messages.APPOINTMENT_BOOK_SUGGESTION, request);
                                this.setSuggestions([]);
                                defered.resolve();
                            }
                        })
                    }
                });
           }
            if (response.data["responseStatus"] != null &&
                response.data["responseStatus"].errors != null &&
                response.data["responseStatus"].errors[0].errorCode == "20121" &&
                response.status === 409) {

                var headerMessage = this.$translate.instant("HEADER_APPOINTMENT_WARNING");
                var continueMessage = this.$translate.instant("MESSAGE_CONTINUE");
                var warningMessageFOV = headerMessage + "<br><br><ul><li> " + response.data["responseStatus"].errors[0].message + "</li></ul><br><br>" + continueMessage;

                this.modalService.alert(warningMessageFOV, 0, true, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' }).then((result) => {
                   if (result) {
                       const request = {
                           payingClientId: payingClient.id,
                           payingClientType: payingClientType,
                           openingContainer: opening,
                           notes: notes,
                           isRequestedEmployee: this.isRequestedEmployee,
                           suppressWarnings: true
                       };

                       this.$http.post(url, request).then(response => {
                           const appointmentsBooked = <number>response.data;
                           if (appointmentsBooked > 0) {
                               this.$rootScope.$broadcast(Messages.APPOINTMENT_BOOK_SUGGESTION, request);
                               this.setSuggestions([]);
                               defered.resolve();
                           }
                       });
                   }
               });
           }
           else {

                defered.resolve();
            }
        });
        return defered.promise;
    }

      public checkIntelliSuggestion(payingClient: Client, payingClientType: ClientTypeEnum, serviceId: any): ng.IPromise<any> {
          this.payingClient = payingClient;

          const deferred = this.$q.defer();
          if (!this.copyScanRequest) {
              this.setSuggestions([]);
              return;
          }

          if (this.copyScanRequest.overallRequestedEmployees && this.copyScanRequest.overallRequestedEmployees.length > 0) {
              this.isRequestedEmployee = true;
          } else {
              this.isRequestedEmployee = false;
          }
          //Check for Client  Intellibooking and businessinfo enableIntelliBooking

          if (this.appSettings.APP_BUSINFOSETTINGS.appointmentBookSettings.enableIntelliBooking && Model.Guard.isSomething(payingClient)) {
              const urlClientCheck = `/${this.appSettings.API_ROOT}/Client/ServiceStepOverrides`;
              var scanedService = {
                  clientId: payingClient.id,
                  serviceGlobalId: this.copyScanRequest.scanServices[0].serviceId
              };

              this.$http.post(urlClientCheck, scanedService).then(response => {
                  var isIntelliClient = response.data;
                  if (_.isArray(isIntelliClient) && !_.isEmpty(isIntelliClient)) {
                      const url = `/${this.appSettings.API_ROOT}/AppointmentBook/Suggestions`;
                      this.modalService.alert("MESSAGE_RESCAN_NEEDED", 0, true, { showCancelButton: false, okButtonContentKey: "LABEL_OK", okButtonHotKey: "MODAL_OK_BUTTON" }).then(result => {
                          if (result) {
                              this.copyScanRequest.clientId = ((payingClient.id) as any);
                              this.copyScanRequest.payingClientId = ((payingClient.id) as any);
                              this.copyScanRequest.scanServices.forEach((service: Model.IScanService) => {
                                  service.clientId =
                                      service.clientId == null ? ((payingClient.id) as any) : service.clientId;
                              });
                              this.$http.post(url, this.copyScanRequest).then(response => {
                                  this.setSuggestions(<ScanOpeningContainer[]>response.data);
                                  deferred.resolve(response.data);
                              });
                          }
                      });
                  } else {
                      this.setSuggestions(this.initScanResult);
                      deferred.resolve();
                  }
              });
          }
          else {
              deferred.resolve(this.suggestions);
          }
          return deferred.promise;
      }


    // TODO: Review and consolidate into another service that can be shared with call center
    public showUdfs(service: Model.ScanOpening): any {
      const appointDetail: any = {
        id: NewGuid(),
        serviceId: service.serviceId,
        serviceDisplayName: service.serviceName
      };
      if (service.answers) {
        appointDetail.customControlsAnswers = service.answers;
      }
      const modalOptions: Meevo.Components.Modal.IModalOptions = {
        templateUrl: "app/plugins/AppointmentBook/views/CustomFields.html",
        controller: "meevo.plugins.appointmentbook.CustomFieldsController",
        controllerAs: "vm",
        bindToController: true,
        additionalClassName: 'appointment-custom-fields-modal',
        locals: {
          appointDetails: [appointDetail],
          appArea: Meevo.Model.AppAreaEnum.Booking,
          canEdit: true
        },
      };
      return this.modalService.showCustom(modalOptions);
    }

    public handleUdfs(opening: ScanOpeningContainer): ng.IPromise<any> {
      const deferred = this.$q.defer();
      const checkProms: ng.IPromise<any>[] = [];
      const udfProms = [];
      opening.serviceOpenings.forEach(serviceOpening => {
        const uri = `/${this.appSettings.API_ROOT}/CustomData/ApptServiceAnswer/List`;
        let request = {
          Criteria: {
            appAreaEnum: Meevo.Model.AppAreaEnum.Booking,
            apptServiceList: [
                {
                    serviceId: serviceOpening.serviceId
                }
            ],
          }
        };

        checkProms.push(this.dataService.customMethodData(uri, 'POST', request)
            .then((response: any) => {
            const hasUdfs = response.data.length > 0;
            if (hasUdfs) {
                udfProms.push(this.showUdfs(serviceOpening)
                    .then((modalResponse: any) => {
                        if (modalResponse.proceed) {
                            serviceOpening.answers = modalResponse.data[0].appointDetail.customControlsAnswers.answers;
                        }
                        return modalResponse;
                    }));
            }
            return response;
        }));

        this.$q.all(checkProms).then(results => {
          if (udfProms.length > 0) {
            this.$q.all(udfProms).then(() => {
              deferred.resolve();
            })
          } else {
            deferred.resolve();
          }
        });
      });

      return deferred.promise;
    }

    private setSuggestions(suggestions: ScanOpeningContainer[]) {
      this.suggestions = suggestions;
      this.$rootScope.$broadcast(Meevo.Components.Common.Messages.APPOINTMENT_SUGGESTIONS_CHANGED, suggestions);
    }

    static factory(): Function {
      let svc = ($q: ng.IQService, $http: ng.IHttpService, $rootScope: ng.IRootScopeService, globals: any, appSettings: IAppSettings, modalService: IModalService, dataService: IDataService,$translate, $locale) => {
          return new SuggestionsService($q, $http, $rootScope, globals, appSettings, modalService, dataService,$translate, $locale);
      }
        svc.$inject = ['$q', '$http', '$rootScope', 'appointmentBookGlobalsService', 'meevo.AppSettings', 'meevo.components.modal.ModalService', 'meevo.components.common.DataService', '$translate', '$locale'];
      return svc;
    }
  }

  angular.module("meevo")
    .factory("meevo.components.suggestionsService", SuggestionsService.factory());
}
